module.exports = __webpack_public_path__ + "media/src/images/share-567eebb3737bd5683561afaf4cec1e55.png";